import React, {useEffect, useMemo, useState} from 'react';
import {useDispatch, useSelector} from 'react-redux';
import {Col, Row} from 'react-bootstrap';
import './Dashboard.scss';
import {FmlxComboBox, FmlxTab} from 'fmlx-common-ui';
import {getReviewSummary, getListProjectLead, getManagerDashboardByPeriods} from './business/dashboardBusiness';
import EmployeeDashbord from './EmployeeDashbord';
import DashboardCardLayout from '../../components/DashboardCardLayout';
import EssSimpleTable from '../../components/MessageTable/TableColumn/EssSimpleTable';
import {getPathByMenuId} from '../../stores/business/appBusiness';
import {useDataProcessor} from '../../hooks/useDataProcessor';
import {useColumnFormat} from '../../hooks/useColumnFormat';
import {usePagination} from '../../hooks/usePagination';
import {useHistory} from 'react-router-dom';
import _ from 'lodash';
import {
  ColumnAccessorEnum,
  EMenuId,
  ERoleId,
  // ManagerAccessorEnum,
  ManagerDataConfig,
  ManagerTableAccessorEnum,
  PaginationEnum,
  StatusConditionEnum,
} from '../../const/dataEnum';
import {formatPeriodDate} from '../../lib/dateTimesHelpers';
import {selectCurrentPeriodId, userAuthRoleIdSelector} from '../../stores/selectors/appStateSelector';
import PropTypes from 'prop-types';

// for the future note: prefer to move pagination to server side, for now pagination is handle in client side

const ManagerDashboard = ({periode}) => {
  const currentPeriodId = useSelector(selectCurrentPeriodId);
  const authRoleID = useSelector(userAuthRoleIdSelector);
  const history = useHistory();
  const dispatch = useDispatch();

  const [dataPerColumn, setDataPerColumn] = useState([]);
  const [selectedTab, setSelectedTab] = useState(0);
  const [reviewTasks, setReviewTask] = useState([]);
  const [listProject, setListProject] = useState([]);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isLoading, setIsLoading]=useState(false);
  const [data, setData] = useState({
    assignedTeamMember: 0,
    teamMember: 0,
    consolidatedReview: 0,
  });

  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(PaginationEnum.PAGE_OPTIONS[0]);
  const [sortConfig, setSortConfig] = useState({key: null, direction: 'asc'});

  const {dataState} = useDataProcessor(reviewTasks, ManagerDataConfig, []);
  const {columnFormat} = useColumnFormat(ColumnAccessorEnum, StatusConditionEnum);
  const {pageOptions, MemoizedEmptyRows} = usePagination(dataState, [], PaginationEnum.PAGE_OPTIONS);

  const tabMenu = {
    PERSONAL: {title: 'Personal', value: 0},
    TEAM: {title: 'Lead', value: 1},
  };

  const generateTableColumns = [
    ManagerTableAccessorEnum.REVIEWER,
    ManagerTableAccessorEnum.PRACTICE,
    ManagerTableAccessorEnum.PROJECT,
    ManagerTableAccessorEnum.LEVEL,
    ManagerTableAccessorEnum.RELATION,
    ManagerTableAccessorEnum.STATUS,
  ];


  // eslint-disable-next-line no-lone-blocks
  {/**TODO: Set the pagination according to backend */}
  useEffect(() => {
    const fetchData = async () => {
      setIsLoading(true); // Start loading

      try {
        const projectId = selectedProject?.id ?? null;

        if (projectId) {
          const response = await dispatch(getManagerDashboardByPeriods(currentPeriodId, projectId));
          setData(response ?? {
            assignedTeamMember: 0,
            teamMember: 0,
            consolidatedReview: 0,
          });

          const data = await dispatch(getReviewSummary(currentPeriodId, projectId));
          setReviewTask(data);

        } else {
          const result = await dispatch(getListProjectLead());
          const projectList = result.map((item) => ({ id: item.id, text: item.projectName }));
          setListProject(projectList);
          if (projectList.length > 0) {
            setSelectedProject(projectList[0]);
          }
        }
      } catch (error) {
        console.error('Error fetching data: ', error.message);
        setReviewTask([]);
      } finally {
        setIsLoading(false); // Stop loading regardless of outcome
      }
    };

    setDataPerColumn(generateTableColumns);
    fetchData();
  }, [authRoleID, dispatch, selectedProject, currentPeriodId]);

  const handleClickGoToPage = (page) => {
    const path = getPathByMenuId(page);
    if (path) {
      history.push(path);
    }
  };

  const handleProjectChange = (id) => {
    setSelectedProject(id);
  };

  const handleChange = ({index}) => {
    setSelectedTab(index);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    const newRowsPerPage = parseInt(event.target.value, 10);

    const startIndex = page * rowsPerPage;
    const newPage = Math.floor(startIndex / newRowsPerPage);

    setRowsPerPage(newRowsPerPage);
    setPage(newPage);
  };

  const slicedData = useMemo(() => {
    const sortedData = sortConfig.key ? _.orderBy(dataState, [sortConfig.key], [sortConfig.direction]) : dataState;
    return _.slice(sortedData, page * rowsPerPage, (page + 1) * rowsPerPage);
  }, [dataState, sortConfig, page, rowsPerPage]);

  const handleSort = (column) => {
    const direction = sortConfig.key === column && sortConfig.direction === 'asc' ? 'desc' : 'asc';
    setSortConfig({key: column, direction});
  };

  const ManagerCardContent = [
    {
      dataFormated: `${formatPeriodDate(periode)}`,
      heading: 'Active Review Period',
    },
    {
      dataFormated: `${data.assignedTeamMember} / ${data.teamMember}`,
      heading: 'Assignment',
      actions: [
        {
          label: 'Go to Assignment',
          onClick: () => handleClickGoToPage(EMenuId.MANAGE_ASSIGNMENT),
        },
      ],
    },
    {
      dataFormated: `${data.consolidatedReview} / ${data.teamMember}`,
      heading: 'Consolidated Review',
      actions: [
        {
          label: 'Go to Consolidation',
          onClick: () => handleClickGoToPage(EMenuId.CONSOLIDATION),
        },
      ],
    },
  ];

  const contentIsManager = () => (
    <>
      <div className="dashboard-info">
        {(authRoleID === ERoleId.ADMINISTRATOR || authRoleID === ERoleId.MANAGER || ERoleId.PRACTICE_LEADER) && (
          <Row>
            <Col className="dashboard-select-project">
              <FmlxComboBox
                placeholder="Select Project"
                items={listProject}
                selectedItem={selectedProject}
                onChange={handleProjectChange}
              />
            </Col>
          </Row>
        )}
        <DashboardCardLayout
          className={'dashboard-info'}
          cardClassName={'dashboard-card'}
          col={3}
          row={1}
          content={ManagerCardContent}
          loading={isLoading}
        />
      </div>
      <div>
        <Row>
          <h4 className="mb-3">Review Task Status</h4>
        </Row>
        <EssSimpleTable
          columnData={dataPerColumn}
          columns={columnFormat}
          onSort={handleSort}
          filteredData={slicedData}
          renderEmptyData={MemoizedEmptyRows}
          dataCount={dataState}
          rowsPerPage={rowsPerPage}
          page={page}
          onChangePage={handleChangePage}
          onChangeRowsPerPage={handleChangeRowsPerPage}
          onPageOption={pageOptions}
        />
      </div>
    </>
  );

  return (
    <>
      {authRoleID === ERoleId.ADMINISTRATOR ? (
        contentIsManager(periode)
      ) : (
        <>
          <FmlxTab
            variant={FmlxTab.Variant.STANDARD}
            type={FmlxTab.Type.OUTLINE}
            items={[tabMenu.PERSONAL, tabMenu.TEAM]}
            onChange={handleChange}
            selectedTab={selectedTab}
          />
          {selectedTab === 0 ? <EmployeeDashbord periode={periode} currentPeriod={currentPeriodId}/> : contentIsManager(periode)}
        </>
      )}
    </>
  );
};

ManagerDashboard.propTypes = {
    periode: PropTypes.oneOfType([PropTypes.string, PropTypes.object]).isRequired,
};

export default ManagerDashboard;
